export function isFirefox() {
  if (window.navigator.userAgent.indexOf('Firefox') !== -1)
    return true
  return false
}